import React from "react";

export type TableRowsContextType = {
    index: number;
};

export const TableRowsContext = React.createContext<TableRowsContextType>({ index: 0 });

export const useTableRowsContext = () => React.useContext(TableRowsContext);
